module.exports = __webpack_public_path__ + "static/img/zhushihua.1024de6d.png";